export default __webpack_public_path__ + "static/pro@mob-94cf9bf624d3a241e724a463edfa0506.webp";